import { useEffect, useState } from "react";
import { addcontactus, InsertPropertyInfo, InsertReservation, InsertSubIntent, saveMandetoryInfo } from "../../Services/chatbot";
import { toast } from "react-toastify";
import "../../assets/chatbotconfig.css"
import ReservationConfig from "../ReservationConfig";
import BookingModeSettings from "./BookingModeSettings";
import { bookingModeOf, bookingSettingsErrors, cancelBookingErrors, DEFAULT_DATE_FORMAT, needsCancelUrl } from "./bookingLink";
import { useRef } from "react";
import ReservationTypesEditor, { ReservationPresetPicker } from "./ReservationTypesEditor";
import MenuButtonsEditor from "./MenuButtonsEditor";
import CancelRequestEditor, { type CancelWay } from "./CancelRequestEditor";
import { CANCEL_REQUEST_MODE_OPTIONS, CancelRequest, cancelRequestErrors, cancelRequestPayload, newCancelRequest, parseCancelRequest } from "./cancelRequest";
import { BedDouble, Bot, Building2, CalendarCheck, CalendarClock, CalendarX2, Globe, ImageIcon, KeyRound, LayoutList, MessageSquare, Plus, RefreshCw, ShieldCheck, Upload, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Separator } from "@/components/ui/separator";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Field, FieldError, FoldPanel, HelpTip, Hint, InfoButton, labelClass, NativeSelect, PageHeader, SubSection, ToggleRow } from "@/components/admin/cards";
import { hasReservationTypeErrors, newReservationType, parseReservationTypes, reservationTypeErrors, reservationTypesPayload, suggestedPreset } from "./reservationTypes";
import { BUSINESS_TYPE_OPTIONS, businessPayload, businessTypeOf, cleanDescription, MAX_ASSISTANT_INSTRUCTIONS, MAX_BUSINESS_DESCRIPTION } from "./businessType";
import { deriveMenuButtons, editableMenuRecord, isDisabled, keyTopicButtons, menuRecordsToSave } from "./menuButtons";

const PROPERTY_TABS = [
  { value: "property", label: "Property & chatbot", icon: <Building2 aria-hidden="true" /> },
  { value: "booking", label: "Booking & menu", icon: <CalendarCheck aria-hidden="true" /> },
  { value: "security", label: "Security", icon: <ShieldCheck aria-hidden="true" /> },
];

/** The tab that shows each field with a validation error. */
const TAB_OF_FIELD: Record<string, string> = {
  property_name: "property", bot_name: "property", welcome_message: "property", chatIcon: "property",
  business_description: "property", assistant_instructions: "property",
  address: "property", email: "property", contactNo: "property", whatsappNo: "property",
  booking_engine_property_id: "booking", booking_url_template: "booking", cancelUrl: "booking", reservation_types: "booking",
  contactLabel: "booking", agentLabel: "booking", cancelLabel: "booking",
  cancelRequestUrl: "booking", cancelRequestEmail: "booking", cancelRequestFields: "booking", cancelRequest: "booking",
};

/** The fold-out panel on the Booking & menu tab that shows each field with a validation error. */
const FOLD_OF_FIELD: Record<string, string> = {
  booking_engine_property_id: "rooms", booking_url_template: "rooms", cancelUrl: "cancelRequest",
  reservation_types: "reservations",
  contactLabel: "menu", agentLabel: "menu", cancelLabel: "menu",
  cancelRequestUrl: "cancelRequest", cancelRequestEmail: "cancelRequest", cancelRequestFields: "cancelRequest", cancelRequest: "cancelRequest",
};

const CANCEL_REQUEST_ERRORS = { cancelRequestUrl: "", cancelRequestEmail: "", cancelRequestFields: "", cancelRequest: "" };

const tabPanelClass = "overflow-visible p-4 data-[state=inactive]:hidden sm:p-5";

const PropertyInfo = ({ cancelData, setButtonName, agentData, setShowInfoImage, showInfoImage, setPublishTrigger, setIsNeedPublish, isDirty, propertyId, data, setPublishing, reservationData, loadInitialData, contactData, csbepropertydata, csbeLinked = true, groupData, isGroup, setIsDirty, onWidgetKeyGenerated, keyTopics }: any) => {

  const [formData, setFormData] = useState<any>({
    //propertyID: propertyId,
    intentID: "property_details",
    bot_name: "",
    property_name: csbepropertydata?.PropertyName,
    welcome_message: "",
    type: "info",
    chaticon: "",
    property_url: "",
    enable_websearch: "y",
    assistant_profile: "hotel",
    business_type: "hotel",
    business_description: "",
    assistant_instructions: "",
    reservation_types: [],
    booking_enabled: true,
    booking_mode: "staah",
    booking_engine: "",
    booking_engine_property_id: "",
    booking_url_template: "",
    booking_date_format: DEFAULT_DATE_FORMAT,
    group_booking_url: "",
    auto_popup_enabled: false,
    timer_seconds: 0,
    widget_key_hash: "",
    allowed_domains: [],
    widget_key_created_at: ""
  });
  const [loading, setLoading] = useState(false)
  const [pluginLoaded, setPluginLoaded] = useState(false);
  const [formErrors, setFormErrors] = useState<any>({
    property_name: "",
    bot_name: "",
    welcome_message: "",
    contactLabel: "",
    address: "",
    email: "",
    contactNo: "",
    chatIcon: "",
    whatsappNo: "",
    agentLabel: ""
  });

  const [isGroupProp, setIsGroupProp] = useState(false);
  const [backupGroupProperty, setBackupGroupProperty] = useState<any>([]);
  const [formJson, setFormJson] = useState<any>({
    label: "",
    content: {},
    isParent: true,
    parentID: "",
    type: "reservation",
    property_type: "P",      // default
    //  propertyID: propertyId,
    group_property: [],
    intentID: "reservation"
  });
  const [contactJson, setcontactJson] = useState<any>({
    label: "",
    content: {
      address: "",
      email: "",
      contactNo: "",
      whatsappNo: "",
      city: ""
    },
    isParent: true,
    parentID: "",
    type: "contact_us",
    //  propertyID: propertyId,
    group_property: [],
    intentID: "contact_us"
  })
  const [initialFormData, setInitialFormData] = useState<any>(null);
  const [initialFormJson, setInitialFormJson] = useState<any>(null);
  const [initialContactJson, setInitialContactJson] = useState<any>(null);
  const [agentJson, setAgentJson] = useState<any>({
    label: "",
    content: {
      whatsappNo: "",
      contactNo: "",
      email: ""
    },
    isParent: true,
    parentID: "",
    type: "talk_to_agent",
    property_type: "P",      // default
    //  propertyID: propertyId,
    group_property: [],
    intentID: "talk_to_agent"
  });
  const [cancelJson, setCancelJson] = useState<any>({
    label: "",
    content: {},
    isParent: true,
    parentID: "",
    type: "cancel_modify_booking",
    property_type: "P",      // default
    //  propertyID: propertyId,
    group_property: [],
    intentID: "cancel_modify_booking"
  });
  const [initialAgentJson, setInitialAgentJson] = useState<any>(null);
  const [initialCancelJson, setInitialCancelJson] = useState<any>(null);
  const [excludeKeywords, setExcludeKeywords] = useState<any>([""]);
  const inputRefs = {
    property_name: useRef<any>(null),
    bot_name: useRef<any>(null),
    welcome_message: useRef<any>(null),
    chatIcon: useRef<any>(null),
    contactLabel: useRef<any>(null),
    address: useRef<any>(null),
    email: useRef<any>(null),
    contactNo: useRef<any>(null),
    whatsappNo: useRef<any>(null),
    agentLabel: useRef<any>(null),
    cancelLabel: useRef<any>(null),
    cancelUrl: useRef<any>(null),
    cancelRequestUrl: useRef<any>(null),
    cancelRequestEmail: useRef<any>(null),
    cancelRequestFields: useRef<any>(null),
    cancelRequest: useRef<any>(null),
    booking_engine_property_id: useRef<any>(null),
    booking_url_template: useRef<any>(null),
    reservation_types: useRef<any>(null),
    business_description: useRef<any>(null),
    assistant_instructions: useRef<any>(null)
  };
  const [showReservationTypeErrors, setShowReservationTypeErrors] = useState(false);
  const [reservationsOn, setReservationsOn] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState<{ title: string; message: string; confirm: string; onConfirm: () => void } | null>(null);
  const lastRoomBookingMode = useRef("staah");
  const [selectedFile, setSelectedFile] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [rawWidgetKey, setRawWidgetKey] = useState("");
  const [isWidgetKeyGenerated, setIsWidgetKeyGenerated] = useState(false);
  const [allowedDomains, setAllowedDomains] = useState<any>([""]);
  const [showWidgetKeyModal, setShowWidgetKeyModal] = useState(false);
  const [activeTab, setActiveTab] = useState("property");
  const [pendingFocus, setPendingFocus] = useState<string | null>(null);
  const [openFolds, setOpenFolds] = useState<Record<string, boolean>>({});

  const focusField = (field) => {
    const el = inputRefs[field]?.current;
    if (!el) return;
    el.scrollIntoView?.({ behavior: "smooth", block: "center" });
    el.focus?.();
  };

  // A field on a closed tab can only take focus once its tab is shown.
  useEffect(() => {
    if (!pendingFocus) return;
    focusField(pendingFocus);
    setPendingFocus(null);
  }, [pendingFocus, activeTab, openFolds]);

  // useEffect(() => {
  //   let propertyName = "";
  //   let propertyURL = "";
  //   if (data?.property_name) {
  //     propertyName = data.property_name;
  //   } else if (csbepropertydata?.PropertyName) {
  //     propertyName = csbepropertydata.PropertyName;
  //   }
  //   if (data?.property_url) {
  //     propertyURL = data.property_url;
  //   }
  //   else if (csbepropertydata?.Website) {
  //     propertyURL = csbepropertydata.Website
  //   }

  //   const { propertyID, ...sanitizedData } = data || {};
  //   setFormData((prev) => ({
  //     ...prev,
  //     ...sanitizedData,
  //     property_name: propertyName,
  //     type: "info",
  //     property_url: propertyURL,
  //     enable_websearch: sanitizedData?.enable_websearch ?? "y"
  //   }));

  // }, [data, csbepropertydata, propertyId]);

  useEffect(() => {
    const propertyName = data?.property_name || csbepropertydata?.PropertyName || "";
    const propertyURL = data?.property_url || csbepropertydata?.Website || "";
    const botName = data?.bot_name || "";
    const { propertyID, ...sanitizedData } = data || {};

    const defaultWelcomeMessage = (prop, bot) =>
      `Welcome to ${prop || "(Your Property)"}\nHello and welcome! I'm your virtual host ${bot} !!`;

    let finalWelcome;
    if (sanitizedData?.welcome_message?.trim()) {
      finalWelcome = sanitizedData.welcome_message;
    } else {
      finalWelcome = defaultWelcomeMessage(propertyName, botName);
    }

    const loadedFormData = {
      property_name: propertyName,
      bot_name: botName,
      property_url: propertyURL,
      welcome_message: finalWelcome,
      chaticon: sanitizedData?.chaticon || "",
      enable_websearch: sanitizedData?.enable_websearch ?? "y",
      assistant_profile: businessTypeOf(sanitizedData) === "hotel" ? "hotel" : "general",
      business_type: businessTypeOf(sanitizedData),
      business_description: String(sanitizedData?.business_description ?? sanitizedData?.businessDescription ?? ""),
      assistant_instructions: String(sanitizedData?.assistant_instructions ?? sanitizedData?.assistantInstructions ?? ""),
      reservation_types: parseReservationTypes(sanitizedData?.reservation_types ?? sanitizedData?.reservationTypes),
      booking_enabled: bookingModeOf(sanitizedData) !== "none",
      booking_mode: bookingModeOf(sanitizedData),
      booking_engine: sanitizedData?.booking_engine || "",
      booking_engine_property_id: sanitizedData?.booking_engine_property_id || "",
      booking_url_template: sanitizedData?.booking_url_template || "",
      booking_date_format: sanitizedData?.booking_date_format || DEFAULT_DATE_FORMAT,
      exclude_keywords: sanitizedData?.exclude_keywords || "",
      group_booking_url: sanitizedData?.group_booking_url || "",
      auto_popup_enabled: Boolean(sanitizedData?.auto_popup_enabled),
      timer_seconds: Number(sanitizedData?.timer_seconds) || 0,
      widget_key_hash: sanitizedData?.widget_key_hash || "",
      allowed_domains: sanitizedData?.allowed_domains || [],
      widget_key_created_at: sanitizedData?.widget_key_created_at || "",
      type: "info",
      intentID: "property_details"
    };

    setFormData(loadedFormData);
    setReservationsOn(loadedFormData.reservation_types.length > 0);
    setAllowedDomains(
      Array.isArray(sanitizedData?.allowed_domains) && sanitizedData.allowed_domains.length > 0
        ? sanitizedData.allowed_domains
        : [""]
    );
    setRawWidgetKey("");
    setIsWidgetKeyGenerated(false);
    setExcludeKeywords(
      sanitizedData?.exclude_keywords
        ? sanitizedData.exclude_keywords.split(",").map((w) => w.trim())
        : [""]
    )
    setInitialFormData(loadedFormData); // ✅ exact same object
  }, [data, csbepropertydata, propertyId]);

  useEffect(() => {
    // Reservation
    let loadedFormJson;
    if (reservationData && reservationData.isModify === "Y") {
      const { propertyID, ...safeData } = reservationData || {};
      loadedFormJson = {
        ...formJson,
        ...safeData,
        intentID: "reservation",
        type: "reservation"
      };
      setIsGroupProp(reservationData.property_type === "G");
    } else {
      const groupPropertyArray = (groupData && isGroup)
        ? Object.keys(groupData || {}).map((propertyId) => {
          const property = groupData[propertyId]?.PropertyData;
          return {
            property_id: property?.PropertyId || "",
            property_name: property?.PropertyName || "",
          };
        })
        : [];
      loadedFormJson = {
        ...formJson,
        group_property: groupPropertyArray,
        property_type: groupPropertyArray.length > 0 ? "G" : "P"
      };
      setIsGroupProp(groupPropertyArray.length > 0);
    }
    loadedFormJson = editableMenuRecord("reservation", loadedFormJson, reservationData?.isModify === "Y");
    setFormJson(loadedFormJson);
    setInitialFormJson(loadedFormJson); // ✅ exact same object
    let locationFallback = "";
    if (csbepropertydata?.Address?.City) {
      locationFallback = csbepropertydata.Address.City;
    } else if (csbepropertydata?.Address?.State) {
      locationFallback = csbepropertydata.Address.State;
    } else if (csbepropertydata?.Address?.Country) {
      locationFallback = csbepropertydata.Address.Country;
    }
    // Contact
    let loadedContactJson;
    if (contactData && contactData.isModify === "Y") {
      const { propertyID, ...safeData } = contactData || {};
      loadedContactJson = {
        ...contactJson,
        ...safeData,
        content: {
          ...safeData.content,
          city: safeData?.content?.city || locationFallback   // ✅ always ensure city
        }
      };

    } else {


      const fullAddress = csbepropertydata?.Address
        ? [
          csbepropertydata.Address.AddressLine,
          csbepropertydata.Address.City,
          csbepropertydata.Address.State,
          csbepropertydata.Address.Country
        ].filter(Boolean).join(", ")
        : "";

      loadedContactJson = {
        ...contactJson,
        content: {
          address: fullAddress,
          city: locationFallback,  // ✅ new field saved
          email: csbepropertydata?.Address?.Email || "",
          contactNo: csbepropertydata?.Address?.Phone || "",
          whatsappNo: ""
        }
      };

    }
    loadedContactJson = editableMenuRecord("contact_us", loadedContactJson, contactData?.isModify === "Y");
    setcontactJson(loadedContactJson);
    setInitialContactJson(loadedContactJson);

    // ✅ Agent
    let loadedAgentJson;
    if (agentData && agentData.isModify === "Y") {
      const { propertyID, ...safeData } = agentData || {};
      loadedAgentJson = { ...agentJson, ...safeData };
    } else {
      loadedAgentJson = { ...agentJson }; // keep defaults
    }
    loadedAgentJson = editableMenuRecord("talk_to_agent", loadedAgentJson, agentData?.isModify === "Y");
    setAgentJson(loadedAgentJson);
    setInitialAgentJson(loadedAgentJson);

    let loadedCancelJson;
    if (cancelData && cancelData.isModify === "Y") {
      const { propertyID, ...safeData } = cancelData || {};
      loadedCancelJson = { ...cancelJson, ...safeData };
    } else {
      loadedCancelJson = { ...cancelJson }; // keep defaults
    }
    loadedCancelJson = editableMenuRecord("cancel_modify_booking", loadedCancelJson, cancelData?.isModify === "Y");
    const loadedCancelRequest = parseCancelRequest(loadedCancelJson.content?.cancelRequest);
    if (loadedCancelRequest) loadedCancelJson = { ...loadedCancelJson, content: { ...loadedCancelJson.content, cancelRequest: loadedCancelRequest } };
    setCancelJson(loadedCancelJson);
    setInitialCancelJson(loadedCancelJson);

  }, [reservationData, contactData, csbepropertydata, groupData, agentData, cancelData, propertyId]);


  useEffect(() => {
    // Don't run until all initial states are loaded
    if (!initialFormData || !initialFormJson || !initialContactJson || !initialAgentJson || !initialCancelJson) {
      return;
    }

    const isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

    const dirty =
      !isEqual(formData, initialFormData) ||
      !isEqual(formJson, initialFormJson) ||
      !isEqual(contactJson, initialContactJson) ||
      !isEqual(agentJson, initialAgentJson) ||
      !isEqual(cancelJson, initialCancelJson);

    setIsDirty(dirty);
  }, [formData, formJson, contactJson, agentJson, cancelJson, initialFormData, initialFormJson, initialContactJson, initialAgentJson, initialCancelJson]);

  const handleKeywordChange = (index, value) => {
    if (value.includes(",")) {
      return; // ignore input if it has a comma
    }
    const updated = [...excludeKeywords];
    updated[index] = value;
    setExcludeKeywords(updated);
    setFormData((prev) => ({
      ...prev,
      exclude_keywords: updated.filter(Boolean).join(", ")
    }));
    setIsDirty(true);
  };

  const uploadToS3 = async (url, file) => {
    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: { "Content-Type": file.type },
        body: file
      });
      if (!res.ok) {
        throw new Error(`S3 responded with ${res.status}`);
      }
      return true;
    } catch (err) {
      console.error("S3 upload failed:", err);
      toast.error("Chat icon could not be uploaded. Please try again.");
      return false;
    }
  };

  const addKeywordField = () => {
    setExcludeKeywords([...excludeKeywords, ""]);
  };

  const removeKeywordField = (index) => {
    const updated = excludeKeywords.filter((_, i) => i !== index);
    setExcludeKeywords(updated.length > 0 ? updated : [""]);
    setFormData((prev) => ({
      ...prev,
      exclude_keywords: updated.filter(Boolean).join(", ")
    }));
    setIsDirty(true);
  };

  const generateWidgetKey = () => {
    const array = new Uint8Array(32);
    window.crypto.getRandomValues(array);
    const key = btoa(String.fromCharCode(...array))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
    setRawWidgetKey(key);
    setIsWidgetKeyGenerated(true);
    setShowWidgetKeyModal(true);
    setIsDirty(true);
  };

  const handleDomainChange = (index, value) => {
    const updated = [...allowedDomains];
    updated[index] = value;
    setAllowedDomains(updated);
    setIsDirty(true);
  };

  const addDomainField = () => {
    setAllowedDomains([...allowedDomains, ""]);
  };

  const removeDomainField = (index) => {
    const updated = allowedDomains.filter((_, i) => i !== index);
    setAllowedDomains(updated.length > 0 ? updated : [""]);
    setIsDirty(true);
  };


  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setIsDirty(true);
    // Clear error for this field when user types
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };




  /*  */

  //  const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   const maxSize = 500 * 1024; // 500 KB
  //   //const minSize = 5 * 1024;  // 10 KB (you can adjust this)

  //   // ✅ Validate file size
  //   if (file.size > maxSize) {
  //     toast.error("File size should not exceed 500 KB");
  //     e.target.value = ""; // clear file input
  //     return;
  //   }

  //   // if (file.size < minSize) {
  //   //   toast.error("File size should be at least 10 KB");
  //   //   e.target.value = ""; // clear file input
  //   //   return;
  //   // }

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     // Save base64 string to formData
  //     setFormData((prev) => ({
  //       ...prev,
  //       chaticon: reader.result,
  //     }));

  //     // ✅ Clear chat icon error if it exists
  //     if (formErrors.chatIcon) {
  //       setFormErrors((prev) => ({ ...prev, chatIcon: "" }));
  //     }
  //   };
  //   reader.readAsDataURL(file); // Converts file to base64
  //   setIsDirty(true);
  // };

  const handleFileChange = (e) => {
    // const file = e.target.files[0];
    const file = e.target.files[0];
    if (!file) return;

    // 🔹 Define size limits
    const maxSize = 1024 * 1024; // 1mb
    const minSize = 10 * 1024;  // 10 KB (optional)

    // 🔹 Check file size
    if (file.size > maxSize) {
      toast.error("File size should not exceed 1 MB");
      e.target.value = ""; // clear file input
      return;
    }

    // if (file.size < minSize) {
    //   toast.error("File size should be at least 10 KB");
    //   e.target.value = ""; // clear file input
    //   return;
    // }
    const preview = URL.createObjectURL(file);
    if (file) {
      // Generate filename: propertyId_datetime.ext
      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      const extension = file.name.split(".").pop();
      const generatedFileName = `${propertyId}_${timestamp}.${extension}`;

      setFormData((prev) => ({
        ...prev,
        chaticon: preview,
        filename: file.name,   // ✅ only filename under chaticon
        content_type: file.type        // ✅ content type as separate field
      }));
      setSelectedFile(file)
      setPreviewUrl(preview);
      // ✅ Clear chat icon error if it exists
      if (formErrors.chatIcon) {
        setFormErrors((prev) => ({ ...prev, chatIcon: "" }));
      }

      setIsDirty(true);
    }
  };

  const handleCheckbox = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      enable_websearch: isChecked ? "y" : ""
    })

    )
    setIsDirty(true);
  }

  const handleBookingSettings = (patch) => {
    setFormData((prev) => ({
      ...prev,
      ...patch,
      ...(patch.booking_mode ? { booking_enabled: patch.booking_mode !== "none" } : {})
    }));
    setFormErrors((prev) => ({ ...prev, booking_engine_property_id: "", booking_url_template: "", cancelUrl: "" }));
    setIsDirty(true);
  }

  const handleSettings = (patch) => {
    setFormData((prev) => ({ ...prev, ...patch }));
    setFormErrors((prev) => ({ ...prev, reservation_types: "", email: "" }));
    setIsDirty(true);
  }

  const isHotel = formData.business_type === "hotel";
  const roomsOn = isHotel && formData.booking_mode !== "none";
  // Only hotels take room bookings; anything else saves booking_mode "none" and no group booking URL.
  const effectiveSettings = isHotel ? formData : { ...formData, booking_mode: "none", booking_enabled: false, group_booking_url: "" };

  const changeBusinessType = (business_type) => {
    if (roomsOn) lastRoomBookingMode.current = formData.booking_mode;
    const apply = () => handleSettings({
      business_type,
      assistant_profile: business_type === "hotel" ? "hotel" : "general",
      ...(business_type === "hotel" ? {} : { booking_mode: "none", booking_enabled: false })
    });
    if (business_type !== "hotel" && roomsOn) {
      setConfirmDialog({
        title: "Room booking will be turned off",
        message: "Only hotels can take room bookings. Your assistant will stop offering rooms when you save.",
        confirm: "Turn off room booking",
        onConfirm: apply
      });
    } else {
      apply();
    }
  }

  const toggleRooms = (on) => {
    if (!on && formData.booking_mode !== "none") lastRoomBookingMode.current = formData.booking_mode;
    handleBookingSettings({ booking_mode: on ? lastRoomBookingMode.current : "none" });
  }

  const toggleReservations = (on) => {
    const types = formData.reservation_types || [];
    if (on || types.length === 0) {
      setReservationsOn(on);
      return;
    }
    setConfirmDialog({
      title: "Remove other reservations?",
      message: `This removes ${types.length === 1 ? "your reservation type" : `your ${types.length} reservation types`} and their settings when you save.`,
      confirm: "Remove",
      onConfirm: () => {
        setReservationsOn(false);
        handleSettings({ reservation_types: [] });
      }
    });
  }

  const addReservationType = (preset) => {
    const types = formData.reservation_types || [];
    handleSettings({ reservation_types: [...types, newReservationType(preset, contactJson.content?.email || "", types)] });
  }

  const menuRecords = {
    reservation: formJson,
    contact_us: contactJson,
    talk_to_agent: agentJson,
    cancel_modify_booking: cancelJson
  };
  const menuSetters = {
    reservation: setFormJson,
    contact_us: setcontactJson,
    talk_to_agent: setAgentJson,
    cancel_modify_booking: setCancelJson
  };
  const handleMenuButton = (key, patch) => {
    menuSetters[key]((prev) => ({ ...prev, ...patch }));
    if (key === "cancel_modify_booking") setFormErrors((prev) => ({ ...prev, cancelUrl: "" }));
    if (key === "contact_us") setFormErrors((prev) => ({ ...prev, address: "", email: "", contactNo: "" }));
    setIsDirty(true);
  }
  const cancelRequest: CancelRequest | null = cancelJson.content?.cancelRequest ?? null;
  const changeCancelRequest = (next: CancelRequest) => {
    setCancelJson((prev) => ({ ...prev, content: { ...prev.content, cancelRequest: next } }));
    setFormErrors((prev) => ({ ...prev, ...CANCEL_REQUEST_ERRORS }));
    setIsDirty(true);
  }
  const chooseCancelWay = (way: CancelWay) => {
    setFormErrors((prev) => ({ ...prev, cancelUrl: "" }));
    if (way === "link") {
      if (cancelRequest) changeCancelRequest({ ...cancelRequest, enabled: false });
      return;
    }
    const base = cancelRequest ?? newCancelRequest(cancelJson.content?.url || "", contactJson.content?.email || "");
    changeCancelRequest({ ...base, enabled: true, mode: way });
  }
  const changeCancelUrl = (url: string) => {
    setCancelJson((prev) => ({ ...prev, content: { ...prev.content, url } }));
    setFormErrors((prev) => ({ ...prev, cancelUrl: "" }));
    setIsDirty(true);
  }
  // Without room bookings or other reservations there is nothing to cancel: the panel is hidden and the request flow saved as off.
  const cancelPanelShown = roomsOn || reservationsOn;
  const activeCancelRequest: CancelRequest | null = cancelPanelShown || !cancelRequest ? cancelRequest : { ...cancelRequest, enabled: false };
  const activeCancelJson = activeCancelRequest === cancelRequest
    ? cancelJson
    : { ...cancelJson, content: { ...cancelJson.content, cancelRequest: activeCancelRequest } };
  const contactButtonOn = !isDisabled(contactJson);
  const hasEnquiryTypes = reservationsOn && (formData.reservation_types || []).some((type) => type.mode === "enquiry");

  const handleAutoPopupCheckbox = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      auto_popup_enabled: isChecked,
      timer_seconds: isChecked ? prev.timer_seconds : 0
    }));
  }

  const handleThemeCheckbox = (e) => {
    const isChecked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      theme_customization: isChecked
    }))
  }
  const handleSaveAll = async () => {
    setLoading(true);

    // Step 1: Validate property info
    const errors: Record<string, any> = {};
    if (!formData.property_name.trim()) errors.property_name = "Property name is required";
    if (!formData.bot_name.trim()) errors.bot_name = "Bot name is required";
    if (!formData.welcome_message.trim()) errors.welcome_message = "Welcome message is required";
    if (!formData.chaticon || formData.chaticon.trim() === "") {
      errors.chatIcon = "Chat icon is required!";
    }
    if ((formData.business_description || "").length > MAX_BUSINESS_DESCRIPTION) {
      errors.business_description = `Keep the description to ${MAX_BUSINESS_DESCRIPTION} characters.`;
    }
    if ((formData.assistant_instructions || "").length > MAX_ASSISTANT_INSTRUCTIONS) {
      errors.assistant_instructions = `Keep the instructions to ${MAX_ASSISTANT_INSTRUCTIONS} characters.`;
    }
    Object.assign(errors, bookingSettingsErrors(effectiveSettings));
    if (!activeCancelRequest?.enabled) Object.assign(errors, cancelBookingErrors(effectiveSettings, cancelJson));
    Object.assign(errors, cancelRequestErrors(activeCancelRequest));

    const typeErrors = reservationTypeErrors(reservationsOn ? formData.reservation_types || [] : []);
    setShowReservationTypeErrors(true);
    if (hasReservationTypeErrors(typeErrors)) {
      errors.reservation_types = "Fix the reservation types highlighted below.";
    }

    // The contact details CSBE supplies are required only while the Contact
    // button is on for a chatbot backed by a STAAH property; an enquiry
    // reservation type also needs the property's contact email.
    const contactRequired = csbeLinked && contactButtonOn;
    if (contactRequired) {
      if (!contactJson.content.address.trim()) errors.address = "Address is required!";
    }

    if (!contactJson.content.email.trim()) {
      if (contactRequired) errors.email = "Email is required!";
      else if (hasEnquiryTypes) errors.email = "Email is required for enquiry reservation types!";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactJson.content.email)) {
      errors.email = "Enter a valid email address!";
    }
    if (!contactJson.content.contactNo.trim()) {
      if (contactRequired) errors.contactNo = "Reservation number is required!";
    } else {
      const contactNo = contactJson.content.contactNo.trim();
      // ✅ Country code is required - must start with +
      if (!contactNo.startsWith("+")) {
        errors.contactNo = "Country code is required (e.g., +91 for India)";
      } else if (!/^\+[1-9]\d{7,14}$/.test(contactNo)) {
        errors.contactNo = "Enter a valid contact number with country code (e.g., +919876543210)";
      }
    }
    
    // ✅ WhatsApp number validation - optional (only validate if provided)
    const whatsApp = contactJson.content.whatsappNo.trim();
    if (whatsApp) {
      // ✅ Country code is required - must start with +
      if (!whatsApp.startsWith("+")) {
        errors.whatsappNo = "Country code is required (e.g., +91 for India)";
      } else if (!/^\+[1-9]\d{7,14}$/.test(whatsApp)) {
        errors.whatsappNo = "Enter a valid WhatsApp number with country code (e.g., +919876543210)";
      }
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);

      const firstErrorField = Object.keys(errors)[0];
      const errorTab = TAB_OF_FIELD[firstErrorField];
      const errorFold = FOLD_OF_FIELD[firstErrorField];
      const foldClosed = errorFold && !openFolds[errorFold];
      if (foldClosed) setOpenFolds((prev) => ({ ...prev, [errorFold]: true }));
      if ((errorTab && errorTab !== activeTab) || foldClosed) {
        if (errorTab) setActiveTab(errorTab);
        setPendingFocus(firstErrorField);
      } else {
        focusField(firstErrorField);
      }
      setLoading(false);
      return;
    }

    const syncedAgentJson = {
      ...agentJson,
      content: {
        ...agentJson.content,
        whatsappNo: contactJson.content.whatsappNo,
        contactNo: contactJson.content.contactNo,
        email: contactJson.content.email
      }
    };
    // Auto-generate widget key on first save if none exists yet
    let autoGeneratedKey = "";
    if (!formData.widget_key_hash && !rawWidgetKey.trim()) {
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);
      autoGeneratedKey = btoa(String.fromCharCode(...array))
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/, "");
    }
    const widgetKeyToSend = rawWidgetKey.trim() || autoGeneratedKey;
    const cancelJsonToSave = activeCancelRequest
      ? { ...cancelJson, content: { ...cancelJson.content, cancelRequest: cancelRequestPayload(activeCancelRequest) } }
      : cancelJson;
    let sentCancelRequest = false;

    try {
      // Step 2: Save property info
      const { propertyID, business_type: _businessType, ...propertyPayload } = effectiveSettings;
      Object.assign(propertyPayload, businessPayload(formData.business_type, formData.business_description));
      propertyPayload.assistant_instructions = cleanDescription(formData.assistant_instructions);
      propertyPayload.timer_seconds = propertyPayload.timer_seconds ? Number(propertyPayload.timer_seconds) : 0;
      propertyPayload.auto_popup_enabled = propertyPayload.timer_seconds > 0 ? Boolean(propertyPayload.auto_popup_enabled) : false;

      // Add raw widget key if generated or auto-generated (backend will hash it)
      if (widgetKeyToSend) {
        propertyPayload.raw_widget_key = widgetKeyToSend;
      }
      // Add allowed domains
      propertyPayload.allowed_domains = allowedDomains.filter(d => d.trim() !== "");
      propertyPayload.reservation_types = reservationTypesPayload(reservationsOn ? propertyPayload.reservation_types || [] : []);
      // Remove read-only fields (backend-managed)
      delete propertyPayload.widget_key_hash;
      delete propertyPayload.widget_key_created_at;
      // A freshly picked file is previewed through an object URL, which only
      // resolves in this tab; the stored icon is the S3 url the API replies with.
      if (typeof propertyPayload.chaticon === "string" && propertyPayload.chaticon.startsWith("blob:")) {
        propertyPayload.chaticon = "";
      }

      const res1 = await InsertPropertyInfo(propertyPayload);

      if (res1?.status === 200) {

        if (res1.data?.presigned_url) {
          await uploadToS3(res1.data.presigned_url, selectedFile);
        }
        const uploadedIconUrl = res1.data?.file_url || res1.data?.fileUrl;
        if (uploadedIconUrl) {
          setFormData(prev => ({
            ...prev,
            chaticon: uploadedIconUrl
          }));
          setPreviewUrl(uploadedIconUrl);
        }

        toast.success("Property info saved!");
        setIsNeedPublish(true)
        setPublishTrigger(prev => prev + 1);
      } else {
        throw new Error(res1?.data?.message || "Failed to save property info");
      }

      // Step 3: Save the menu records that exist, override a button or carry data
      const items = menuRecordsToSave(
        { ...menuRecords, talk_to_agent: syncedAgentJson, cancel_modify_booking: cancelJsonToSave },
        {
          reservation: reservationData?.isModify === "Y",
          contact_us: contactData?.isModify === "Y",
          talk_to_agent: agentData?.isModify === "Y",
          cancel_modify_booking: cancelData?.isModify === "Y"
        }
      );
      if (items.length > 0) {
        sentCancelRequest = items.some((item) => item.intentID === "cancel_modify_booking" && item.content?.cancelRequest);
        const res2 = await saveMandetoryInfo({ item: items });
        if (res2?.status === 200) {
          setIsNeedPublish(true)
          setPublishTrigger(prev => prev + 1);
        } else {
          throw new Error(res2?.data?.message || "Failed to save reservation/contact info");
        }
      }
      setIsDirty(false);
      // Reload data
      await loadInitialData();
      setBackupGroupProperty([]);

      // Show widget key modal via parent callback (survives PropertyInfo remount)
      const keyToShow = res1?.data?.raw_widget_key || widgetKeyToSend;
      if (keyToShow && onWidgetKeyGenerated) {
        onWidgetKeyGenerated(keyToShow);
      }
    } catch (error) {
      if (sentCancelRequest && error?.status === 400 && error.message) {
        // The admin API rejected the cancel request settings and saved none of the menu records.
        setFormErrors((prev) => ({ ...prev, cancelRequest: error.message }));
        setOpenFolds((prev) => ({ ...prev, cancelRequest: true }));
        setActiveTab("booking");
        setPendingFocus("cancelRequest");
        toast.error(`Cancel booking request not saved: ${error.message}`);
      } else {
        toast.error(error.message || "Something went wrong");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };



  const showInfo = (name) => () => {
    setShowInfoImage(true);
    setButtonName(name);
  };
  const tabsWithErrors = new Set(
    Object.entries(formErrors).filter(([, message]) => message).map(([field]) => TAB_OF_FIELD[field]).filter(Boolean)
  );
  const hasReservationTypes = reservationsOn && (formData.reservation_types || []).length > 0;
  const canSave = !data || isDirty || (agentData && Object.keys(agentData).length === 0) || (cancelData && Object.keys(cancelData).length === 0);

  const foldsWithErrors = new Set(
    Object.entries(formErrors).filter(([, message]) => message).map(([field]) => FOLD_OF_FIELD[field]).filter(Boolean)
  );
  const fold = (name: string) => ({
    open: !!openFolds[name],
    onOpenChange: (open: boolean) => setOpenFolds((prev) => ({ ...prev, [name]: open })),
    hasError: foldsWithErrors.has(name),
  });
  const reservationTypeCount = (formData.reservation_types || []).length;
  const cancelUrlNeeded = needsCancelUrl(effectiveSettings);
  const cancelLinkLabel = !roomsOn ? "No Cancel button" : cancelUrlNeeded ? "Open our cancel page" : "Open the booking engine's cancel page";
  const cancelRequestSummary = cancelRequest?.enabled
    ? `${CANCEL_REQUEST_MODE_OPTIONS.find((option) => option.value === cancelRequest.mode)?.label} · ${cancelRequest.fields.length === 1 ? "1 detail" : `${cancelRequest.fields.length} details`}`
    : cancelUrlNeeded && !(cancelJson.content?.url || "").trim() ? "No cancel page link yet" : cancelLinkLabel;

  const groupBookingUrlField = (
    <Field label="Group Booking URL" htmlFor="groupBookingUrl" onExample={showInfo("groupurl")}
      hint="Where groups go to ask for a group booking.">
      <Input id="groupBookingUrl" placeholder="Enter group booking url" name="group_booking_url"
        value={formData.group_booking_url} onChange={onChange} />
    </Field>
  );

  const addRemoveButtons = (index, list, value, add, remove, noun) => (
    <>
      {index === list.length - 1 && (
        <Button type="button" variant="outline" size="icon" className="size-9 shrink-0" aria-label={`Add ${noun}`}
          onClick={add} disabled={!value.trim()}>
          <Plus aria-hidden="true" />
        </Button>
      )}
      {list.length > 1 && (
        <Button type="button" variant="outline" size="icon" className="size-9 shrink-0 text-destructive" aria-label={`Remove ${noun} ${index + 1}`}
          onClick={() => remove(index)}>
          <X aria-hidden="true" />
        </Button>
      )}
    </>
  );

  return (
    <div className="position-relative">
      {loading && (
        <div className="loaderOverlay d-flex justify-content-center align-items-center">
          <div className="loading"><div className="main-loader"></div></div>
        </div>
      )}
      <section data-evo-island aria-labelledby="propertyInfoHeading"
        className={cn("flex flex-col gap-4 text-foreground", loading && "pointer-events-none blur-sm")}>
        <PageHeader id="propertyInfoHeading" icon={<Building2 />} title="Property Information"
          description="Your business, what guests can book and where the chatbot appears." />

        <Tabs value={activeTab} onValueChange={setActiveTab}
          className="gap-0 rounded-xl border border-border bg-card text-card-foreground shadow-sm">
          <TabsList aria-label="Property information sections"
            className="h-auto w-full justify-start gap-1 overflow-x-auto rounded-none border-b border-border bg-transparent p-0 px-2">
            {PROPERTY_TABS.map((tab) => (
              <TabsTrigger key={tab.value} value={tab.value}
                className="relative h-auto flex-none rounded-none border-0 px-3 py-2.5 text-muted-foreground shadow-none after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:rounded-full hover:text-foreground data-[state=active]:bg-transparent data-[state=active]:text-primary data-[state=active]:shadow-none data-[state=active]:after:bg-primary dark:text-muted-foreground dark:data-[state=active]:border-0 dark:data-[state=active]:bg-transparent dark:data-[state=active]:text-primary">
                {tab.icon}
                {tab.label}
                {tabsWithErrors.has(tab.value) && (
                  <span className="size-1.5 rounded-full bg-destructive"><span className="sr-only">(has errors)</span></span>
                )}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value="property" forceMount data-section="property" className={tabPanelClass}>
            <div className="grid gap-5 2xl:grid-cols-2 2xl:gap-0 max-2xl:divide-y 2xl:divide-x divide-border">
              <SubSection icon={<Building2 />} title="Property details" description="Name, website and how guests reach you"
                className="max-2xl:pb-5 2xl:pr-5">
                <div className="grid gap-3 sm:grid-cols-2">
                  <Field label="Property Name" htmlFor="propertyName" required error={formErrors.property_name}>
                    <Input id="propertyName" placeholder="Enter property name" name="property_name"
                      value={formData.property_name} ref={inputRefs.property_name} onChange={onChange} />
                  </Field>
                  <Field label="Property URL" htmlFor="propertyUrl">
                    <Input id="propertyUrl" placeholder="Enter property url" name="property_url"
                      value={formData.property_url} onChange={onChange} />
                  </Field>
                </div>
                <div className="grid gap-3 sm:grid-cols-2">
                  <div className="flex min-w-0 flex-col gap-1.5">
                    <div className="flex items-center gap-1">
                      <Label htmlFor="businessDescription" className={labelClass}>Business description (optional)</Label>
                      <HelpTip label="Business description" id="businessDescriptionHint">Shown to the assistant as information about your business</HelpTip>
                    </div>
                    <Textarea
                      id="businessDescription"
                      aria-describedby="businessDescriptionHint"
                      rows={2}
                      maxLength={MAX_BUSINESS_DESCRIPTION}
                      ref={inputRefs.business_description}
                      placeholder="e.g. Family-run Italian restaurant in the old town"
                      value={formData.business_description || ""}
                      onChange={(e) => {
                        handleSettings({ business_description: e.target.value });
                        setFormErrors((prev) => ({ ...prev, business_description: "" }));
                      }}
                    />
                    <div className="flex justify-end text-xs text-muted-foreground">
                      <span>{(formData.business_description || "").length}/{MAX_BUSINESS_DESCRIPTION}</span>
                    </div>
                    <FieldError message={formErrors.business_description} />
                  </div>
                  <div className="flex min-w-0 flex-col gap-1.5">
                    <div className="flex items-center gap-1">
                      <Label htmlFor="assistantInstructions" className={labelClass}>Assistant instructions (optional)</Label>
                      <HelpTip label="Assistant instructions" id="assistantInstructionsHint">
                        Tell the chatbot how to talk to guests, for example its tone or what to mention or avoid. It can't change what guests can book.
                      </HelpTip>
                    </div>
                    <Textarea
                      id="assistantInstructions"
                      rows={2}
                      maxLength={MAX_ASSISTANT_INSTRUCTIONS}
                      ref={inputRefs.assistant_instructions}
                      aria-describedby="assistantInstructionsHint"
                      placeholder="e.g. Be warm and friendly. Keep answers short. Always mention our free parking. Never talk about other hotels."
                      value={formData.assistant_instructions || ""}
                      onChange={(e) => {
                        handleSettings({ assistant_instructions: e.target.value });
                        setFormErrors((prev) => ({ ...prev, assistant_instructions: "" }));
                      }}
                    />
                    <div className="flex justify-end text-xs text-muted-foreground">
                      <span>{(formData.assistant_instructions || "").length}/{MAX_ASSISTANT_INSTRUCTIONS}</span>
                    </div>
                    <FieldError message={formErrors.assistant_instructions} />
                  </div>
                </div>
                <ReservationConfig inputRefs={inputRefs} isGroupProp={isGroupProp} setIsGroupProp={setIsGroupProp}
                  backupGroupProperty={backupGroupProperty} setBackupGroupProperty={setBackupGroupProperty} formJson={formJson} setFormJson={setFormJson}
                  contactJson={contactJson} setcontactJson={setcontactJson}
                  data={reservationData} propertyId={propertyId} loadInitialData={loadInitialData} contactData={contactData} csbepropertydata={csbepropertydata} groupData={groupData} isGroup={isGroup}
                  loading={loading} setLoading={setLoading} formErrors={formErrors} setFormErrors={setFormErrors}
                  setIsDirty={setIsDirty} setShowInfoImage={setShowInfoImage} showInfoImage={showInfoImage}
                  setAgentJson={setAgentJson} agentJson={agentJson} setButtonName={setButtonName} cancelJson={cancelJson} setCancelJson={setCancelJson}
                  contactRequired={csbeLinked && contactButtonOn} contactEmailRequired={hasEnquiryTypes}
                />
              </SubSection>

              <SubSection icon={<Bot />} title="Chatbot identity" description="How the chatbot introduces itself"
                className="max-2xl:pt-5 2xl:pl-5">
                <div className="grid gap-3 sm:grid-cols-2">
                  <Field label="Name Your Bot" htmlFor="botName" required error={formErrors.bot_name}>
                    <Input id="botName" placeholder="Enter bot name" name="bot_name"
                      ref={inputRefs.bot_name} value={formData.bot_name} onChange={onChange} />
                  </Field>
                  <Field label="Chat Icon" htmlFor="chatIconUpload" required error={formErrors.chatIcon}>
                    <div className="flex items-center gap-3">
                      <span className="flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full border border-border bg-muted text-muted-foreground">
                        {(previewUrl || formData.chaticon) ? (
                          <img src={previewUrl || formData.chaticon} alt="Chat Icon" className="size-full object-cover" />
                        ) : (
                          <ImageIcon className="size-4" aria-hidden="true" />
                        )}
                      </span>
                      <label className="inline-flex h-9 cursor-pointer items-center gap-2 rounded-md border border-input bg-background px-3 text-sm font-medium shadow-xs hover:bg-accent has-[:focus-visible]:ring-[3px] has-[:focus-visible]:ring-ring/50 dark:bg-input/30">
                        <Upload className="size-4" aria-hidden="true" />
                        Upload icon
                        <input id="chatIconUpload" type="file" className="sr-only" name="chaticon"
                          ref={inputRefs.chatIcon} onChange={handleFileChange} />
                      </label>
                    </div>
                  </Field>
                </div>
                <Field label="Welcome message" htmlFor="welcomeMessage" required error={formErrors.welcome_message}>
                  <Textarea id="welcomeMessage" placeholder="Enter welcome message for your bot" rows={3} name="welcome_message"
                    value={formData.welcome_message} ref={inputRefs.welcome_message} onChange={onChange} />
                </Field>

                <ToggleRow id="flexCheckDefault" icon={<Globe />} title="Allow answers from general knowledge (web search)"
                  description="When off, the assistant answers only from your FAQs and knowledge sources."
                  checked={formData.enable_websearch === "y"} onChange={handleCheckbox} />
                <ToggleRow id="autoPopupCheck" icon={<MessageSquare />} title="Auto pop-up"
                  description="Opens the chat window by itself after a few seconds."
                  onExample={showInfo("autopopup")}
                  checked={formData.auto_popup_enabled || false} onChange={handleAutoPopupCheckbox}>
                  {formData.auto_popup_enabled && (
                    <div className="flex shrink-0 items-center gap-1.5">
                      <Input
                        id="autoPopupSeconds"
                        aria-label="Seconds"
                        className="h-8 w-16"
                        type="number"
                        placeholder="5"
                        name="timer_seconds"
                        min="0"
                        max="60"
                        step="1"
                        value={formData.timer_seconds !== undefined && formData.timer_seconds !== null ? String(formData.timer_seconds) : ""}
                        onFocus={(e) => e.target.select()}
                        onChange={(e) => {
                          const raw = e.target.value;
                          if (raw === "") {
                            setFormData((prev) => ({ ...prev, timer_seconds: 0 }));
                            return;
                          }
                          let num = parseInt(raw, 10);
                          if (isNaN(num)) return;
                          if (num > 60) num = 60;
                          if (num < 0) num = 0;
                          setFormData((prev) => ({
                            ...prev,
                            timer_seconds: num
                          }));
                        }}
                      />
                      <span className="text-xs text-muted-foreground">sec</span>
                      <InfoButton label="Auto pop-up seconds example" onClick={showInfo("autopopuptimer")} />
                    </div>
                  )}
                </ToggleRow>

                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-1">
                    <span className={labelClass}>Exclude Keywords</span>
                    <HelpTip label="Exclude Keywords" onExample={showInfo("exclude")}>Words the chatbot should not answer about.</HelpTip>
                  </div>
                  <div className="grid gap-2 sm:grid-cols-2">
                    {excludeKeywords.map((keyword, index) => (
                      <div key={index} className="flex items-center gap-2">
                        <Input aria-label={`Exclude keyword ${index + 1}`} placeholder="Enter keyword" value={keyword}
                          onChange={(e) => handleKeywordChange(index, e.target.value)} />
                        {addRemoveButtons(index, excludeKeywords, keyword, addKeywordField, removeKeywordField, "keyword")}
                      </div>
                    ))}
                  </div>
                </div>
              </SubSection>
            </div>
          </TabsContent>

          <TabsContent value="booking" forceMount data-section="booking" className={tabPanelClass}>
            <SubSection icon={<CalendarCheck />} title="Business type & booking" description="What guests can book in the chat">
              <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]">
                <Field label="Business type" htmlFor="businessTypeSelect" hint="Changes the suggested reservations and whether hotel rooms can be booked.">
                  <NativeSelect id="businessTypeSelect" value={formData.business_type || "hotel"}
                    onChange={(e) => changeBusinessType(e.target.value)}>
                    {BUSINESS_TYPE_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </NativeSelect>
                </Field>
                <div className="flex min-w-0 flex-col gap-1.5">
                  <div className="flex items-center gap-1">
                    <span className={labelClass}>What can guests book?</span>
                    <HelpTip label="What can guests book">Each thing guests can book gets its own menu button.</HelpTip>
                  </div>
                  <div className="grid gap-2 sm:grid-cols-2">
                    {isHotel ? (
                      <ToggleRow compact id="capabilityRooms" icon={<BedDouble />} title="Hotel rooms"
                        description="Regular stays and day-use packages." checked={roomsOn}
                        onChange={(e) => toggleRooms(e.target.checked)} />
                    ) : (
                      <p className="flex min-h-9 items-center gap-2 rounded-md border border-dashed border-border px-3 py-1.5 text-xs text-muted-foreground">
                        <BedDouble className="size-4 shrink-0" aria-hidden="true" />
                        Room booking is only for hotels. Choose Hotel to offer rooms.
                      </p>
                    )}
                    <ToggleRow compact id="capabilityReservations" icon={<CalendarClock />} title="Other reservations"
                      description="Such as a table, an appointment or a spa treatment."
                      checked={reservationsOn} onChange={(e) => toggleReservations(e.target.checked)} />
                  </div>
                  {!roomsOn && !reservationsOn && <Hint>Your assistant will only answer questions (no bookings)</Hint>}
                  {!isHotel && formData.booking_mode !== "none" && (
                    <div className="rounded-lg border border-warning-300 bg-warning-50 px-4 py-2 text-sm text-warning-700" role="alert">
                      Room booking will be turned off when you save, because only hotels take room bookings. Choose Hotel to keep it.
                    </div>
                  )}
                  {isHotel && !roomsOn && <div className="sm:max-w-sm">{groupBookingUrlField}</div>}
                </div>
              </div>

              {(roomsOn || hasReservationTypes || reservationsOn) && (
                <div className="flex flex-col gap-3">
                  {(roomsOn || hasReservationTypes) && <p className={labelClass}>Booking settings</p>}
                  {roomsOn && (
                    <FoldPanel {...fold("rooms")} icon={<BedDouble />} title="Hotel rooms" summary="Booking engine and booking links"
                      role="group" aria-label="Hotel room settings">
                      <BookingModeSettings
                        settings={formData}
                        errors={formErrors}
                        onChange={handleBookingSettings}
                        propertyIdRef={inputRefs.booking_engine_property_id}
                        templateRef={inputRefs.booking_url_template}
                      >
                        <div className="grid gap-3 md:grid-cols-2">
                          {groupBookingUrlField}
                        </div>
                      </BookingModeSettings>
                    </FoldPanel>
                  )}
                  {reservationsOn && (
                    <FoldPanel {...fold("reservations")} icon={<CalendarClock />} title="Other reservations"
                      summary={reservationTypeCount === 1 ? "1 reservation type" : `${reservationTypeCount} reservation types`}
                      role="group" aria-label="Other reservation settings">
                      <ReservationPresetPicker suggested={suggestedPreset(formData.business_type)} onAdd={addReservationType} />
                      <ReservationTypesEditor
                        types={formData.reservation_types || []}
                        errors={showReservationTypeErrors ? reservationTypeErrors(formData.reservation_types || []) : []}
                        onChange={(types) => handleSettings({ reservation_types: types })}
                      />
                    </FoldPanel>
                  )}
                </div>
              )}
              <div ref={inputRefs.reservation_types}>
                <FieldError message={formErrors.reservation_types} />
              </div>
            </SubSection>

            <Separator className="my-5" />

            {cancelPanelShown && (
            <FoldPanel {...fold("cancelRequest")} icon={<CalendarX2 />} title="Cancel booking" summary={cancelRequestSummary}
              role="group" aria-label="Cancel booking" className="mb-3">
              <CancelRequestEditor
                value={cancelRequest}
                errors={formErrors}
                linkLabel={cancelLinkLabel}
                cancelUrl={cancelUrlNeeded ? cancelJson.content?.url || "" : null}
                onCancelUrl={changeCancelUrl}
                onChoose={chooseCancelWay}
                onChange={changeCancelRequest}
                cancelUrlRef={inputRefs.cancelUrl}
                urlRef={inputRefs.cancelRequestUrl}
                emailRef={inputRefs.cancelRequestEmail}
                fieldsRef={inputRefs.cancelRequestFields}
                errorRef={inputRefs.cancelRequest}
              />
            </FoldPanel>
            )}

            <FoldPanel {...fold("menu")} icon={<LayoutList />} title="Menu buttons" summary="Buttons guests see in the chat menu"
              role="group" aria-label="Menu buttons">
              <MenuButtonsEditor
                buttons={deriveMenuButtons(effectiveSettings, reservationsOn ? formData.reservation_types || [] : [], {
                  ...menuRecords,
                  cancel_modify_booking: activeCancelJson,
                  talk_to_agent: { ...agentJson, content: { ...agentJson.content, whatsappNo: contactJson.content.whatsappNo, contactNo: contactJson.content.contactNo } }
                })}
                keyTopics={keyTopicButtons(keyTopics)}
                onChange={handleMenuButton}
                onInfo={(name) => showInfo(name)()}
                labelRefs={{ cancel_modify_booking: inputRefs.cancelLabel, contact_us: inputRefs.contactLabel, talk_to_agent: inputRefs.agentLabel }}
              />
            </FoldPanel>
          </TabsContent>

          <TabsContent value="security" forceMount data-section="security" className={tabPanelClass}>
            <SubSection icon={<ShieldCheck />} title="Security" description="Run the chatbot only on your own websites">
              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-1">
                  <span className={labelClass}>Widget Key</span>
                  <InfoButton label="Widget security example" onClick={showInfo("widgetsecurity")} />
                </div>
                <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border px-4 py-3">
                  <KeyRound className="size-4 text-muted-foreground" aria-hidden="true" />
                  {formData.widget_key_created_at ? (
                    <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
                      <Badge variant="success">Active</Badge>
                      <span className="text-xs text-muted-foreground">
                        Key created: {new Date(formData.widget_key_created_at).toLocaleString()}
                      </span>
                    </div>
                  ) : (
                    <span className="min-w-0 flex-1 text-sm text-muted-foreground">No widget key generated yet</span>
                  )}
                  <Button type="button" variant="outline" size="sm" onClick={generateWidgetKey} disabled={isWidgetKeyGenerated}>
                    {formData.widget_key_created_at
                      ? <><RefreshCw aria-hidden="true" /> Regenerate Key</>
                      : <><Plus aria-hidden="true" /> Auto-Generate</>}
                  </Button>
                </div>
                {isWidgetKeyGenerated && (
                  <Hint>{formData.widget_key_created_at ? "New key generated — click Save to apply" : "Key generated — click Save to apply"}</Hint>
                )}
              </div>

              <div className="flex flex-col gap-1.5">
                <div className="flex items-center gap-1">
                  <span className={labelClass}>Allowed Domains</span>
                  <HelpTip label="Allowed Domains" onExample={showInfo("alloweddomains")}>
                    Add the website domain(s) where you want to embed the chatbot. The chatbot will only load on these domains.
                    For example: <code className="rounded bg-muted px-1">myhotel.com</code> or <code className="rounded bg-muted px-1">*.myhotel.com</code> (to allow all subdomains).
                  </HelpTip>
                </div>
                <div className="grid gap-2 md:grid-cols-2">
                  {allowedDomains.map((domain, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <Input aria-label={`Allowed domain ${index + 1}`} placeholder="e.g. hotel.com or *.hotel.com" value={domain}
                        onChange={(e) => handleDomainChange(index, e.target.value)} />
                      {addRemoveButtons(index, allowedDomains, domain, addDomainField, removeDomainField, "domain")}
                    </div>
                  ))}
                </div>
              </div>
            </SubSection>
          </TabsContent>
        </Tabs>

        {canSave && (
          <footer className="sticky bottom-0 z-10 flex items-center justify-end gap-2 rounded-xl border border-border bg-card px-5 py-3 shadow-sm">
            <Button type="button" onClick={handleSaveAll}>Save</Button>
          </footer>
        )}
      </section>

      <Dialog open={Boolean(confirmDialog)} onOpenChange={(open) => !open && setConfirmDialog(null)}>
        <DialogContent data-evo-island showCloseButton={false} className="text-foreground sm:max-w-md">
          {confirmDialog && (
            <>
              <DialogHeader className="text-left">
                <DialogTitle>{confirmDialog.title}</DialogTitle>
                <DialogDescription>{confirmDialog.message}</DialogDescription>
              </DialogHeader>
              <DialogFooter>
                <Button type="button" variant="outline" onClick={() => setConfirmDialog(null)}>Cancel</Button>
                <Button
                  type="button"
                  onClick={() => {
                    confirmDialog.onConfirm();
                    setConfirmDialog(null);
                  }}
                >
                  {confirmDialog.confirm}
                </Button>
              </DialogFooter>
            </>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PropertyInfo;
